import {utils} from '../configured';

export const {
  browserHistory,
  GoogleAnalytics,
  pageAnalytics,
  request,
  requestService,
  sentry,
} = utils;
